/* tslint:disable */
/* eslint-disable */
/**
 * Bikeleasing Accounts
 * Consumers of the API must follow the tolerant reader pattern. Especially the consumer    * must ignore unknown properties   * expect enumerations to be extended at any time (this includes discriminators)      These changes are considered backwards compatible.   However, we will never do a backwards-incompatible change without creating a new API version:   * removal of required properties   * removal of a supported request parameter   * adding a new required request parameter or attributes   * renaming of an attribute      All responses contain a common header `X-Request-Id` which identifies the individual HTTP request. This ID should be included in any bug reports or support requests.  There is a per-client rate limit on the API. If the rate limit is exceeded (resulting in a \"429 Too Many Requests\" response), please slow down and retry  after a short delay.  The API strives to return status codes that align with user expectations. However, in some error cases, multiple status codes may seem appropriate, and  the expected status code might not be clear. Here are two important points to consider when dealing with error status codes: 1. The API first checks the user\'s permission to access a resource. Only if the user has permission, it attempts to retrieve the resource. As a consequence, a user will     see a `403 Access Denied` status when requesting non-existent single resources since the permission check fails first. 2. There are no permissions on collections, only on the resources contained within them. Therefore, the API never returns a `403 Access Denied` status because the user     lacks permission to access a collection. Instead, the API returns a list containing all resources the user has permission to access. If the user has no permission to any     resource in the collection, an empty list with a `200 OK` status code is returned.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Company } from '../dto';
// @ts-ignore
import type { InlineObject } from '../dto';
// @ts-ignore
import type { InlineObject1 } from '../dto';
// @ts-ignore
import type { InlineObject2 } from '../dto';
// @ts-ignore
import type { PatchDocumentInner } from '../dto';
// @ts-ignore
import type { PublicCompanyResponse } from '../dto';
/**
 * CompaniesApi - axios parameter creator
 * @export
 */
export const CompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Soft deletes the company with the specified ID. The current state of a company is also published in Kafka with exactly the same data structure in the `accounts.company.entity.v1` topic with the `companyId` header set to the company ID.
         * @param {string} companyId The company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('deleteCompany', 'companyId', companyId)
            const localVarPath = `/api/v1/companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["companies:write"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the company with the specified ID. The current state of a company is also published in Kafka with exactly the same data structure in the `accounts.company.entity.v1` topic with the `companyId` header set to the company ID.
         * @param {string} companyId The company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompany', 'companyId', companyId)
            const localVarPath = `/api/v1/companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["companies:read"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve limited public information about a company by its UUID. This endpoint is publicly accessible and does not require authentication. Returns only the company ID and name.
         * @summary Get public company information
         * @param {string} uuid The unique identifier of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCompany: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPublicCompany', 'uuid', uuid)
            const localVarPath = `/api/v1/public/companies/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies a JSON Patch document to partially update a company. Only the fields provided in the patch document will be updated; all other fields remain unchanged.  Expected error types for bad requests: - error:account@bikeleasing:context-missing - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:invalid-patch-operation 
         * @param {string} companyId The company identifier
         * @param {Array<PatchDocumentInner>} patchDocumentInner 
         * @param {string} [ifMatch] The expected version of the resource, as returned in the &#x60;etag&#x60; response. If the version does not match the current version of the resource, a &#x60;412 Precondition Failed&#x60; response is returned.  It is important that the If-Match header encloses the ETag value in double quotes, as specified in [RFC 7232, Section 3.1](https://datatracker.ietf.org/doc/html/rfc7232#section-3.1) to prevent parsing issues.  This header can be used to implement optimistic concurrency control. If not provided, no version check is performed and the update is applied unconditionally. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCompany: async (companyId: string, patchDocumentInner: Array<PatchDocumentInner>, ifMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('patchCompany', 'companyId', companyId)
            // verify required parameter 'patchDocumentInner' is not null or undefined
            assertParamExists('patchCompany', 'patchDocumentInner', patchDocumentInner)
            const localVarPath = `/api/v1/companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["companies:write"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['If-Match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchDocumentInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new company.  If a company is created with a Bikeleasing context, the client is allowed to create it with a CRM Id and a company code. In that case both fields are required and the account service will not generate a company code.  Expected error types for bad requests: - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:context-missing - error:account@bikeleasing:crm-id-and-company-code-required - error:account@bikeleasing:active-company-required - error:account@bikeleasing:company-code-must-be-unique 
         * @param {Company} company 
         * @param {PostCompanyBypassConflictsEnum} [bypassConflicts] When set to \&quot;true\&quot;, the server will skip checking for potential duplicate companies. This header should only be used in special cases where the client is certain that the data is valid and wants to bypass these checks. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompany: async (company: Company, bypassConflicts?: PostCompanyBypassConflictsEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'company' is not null or undefined
            assertParamExists('postCompany', 'company', company)
            const localVarPath = `/api/v1/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["companies:write"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (bypassConflicts != null) {
                localVarHeaderParameter['Bypass-Conflicts'] = String(bypassConflicts);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * Soft deletes the company with the specified ID. The current state of a company is also published in Kafka with exactly the same data structure in the `accounts.company.entity.v1` topic with the `companyId` header set to the company ID.
         * @param {string} companyId The company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompany(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompany(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.deleteCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the company with the specified ID. The current state of a company is also published in Kafka with exactly the same data structure in the `accounts.company.entity.v1` topic with the `companyId` header set to the company ID.
         * @param {string} companyId The company identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompany(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompany(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.getCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve limited public information about a company by its UUID. This endpoint is publicly accessible and does not require authentication. Returns only the company ID and name.
         * @summary Get public company information
         * @param {string} uuid The unique identifier of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicCompany(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicCompany(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.getPublicCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Applies a JSON Patch document to partially update a company. Only the fields provided in the patch document will be updated; all other fields remain unchanged.  Expected error types for bad requests: - error:account@bikeleasing:context-missing - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:invalid-patch-operation 
         * @param {string} companyId The company identifier
         * @param {Array<PatchDocumentInner>} patchDocumentInner 
         * @param {string} [ifMatch] The expected version of the resource, as returned in the &#x60;etag&#x60; response. If the version does not match the current version of the resource, a &#x60;412 Precondition Failed&#x60; response is returned.  It is important that the If-Match header encloses the ETag value in double quotes, as specified in [RFC 7232, Section 3.1](https://datatracker.ietf.org/doc/html/rfc7232#section-3.1) to prevent parsing issues.  This header can be used to implement optimistic concurrency control. If not provided, no version check is performed and the update is applied unconditionally. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCompany(companyId: string, patchDocumentInner: Array<PatchDocumentInner>, ifMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCompany(companyId, patchDocumentInner, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.patchCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new company.  If a company is created with a Bikeleasing context, the client is allowed to create it with a CRM Id and a company code. In that case both fields are required and the account service will not generate a company code.  Expected error types for bad requests: - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:context-missing - error:account@bikeleasing:crm-id-and-company-code-required - error:account@bikeleasing:active-company-required - error:account@bikeleasing:company-code-must-be-unique 
         * @param {Company} company 
         * @param {PostCompanyBypassConflictsEnum} [bypassConflicts] When set to \&quot;true\&quot;, the server will skip checking for potential duplicate companies. This header should only be used in special cases where the client is certain that the data is valid and wants to bypass these checks. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompany(company: Company, bypassConflicts?: PostCompanyBypassConflictsEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompany(company, bypassConflicts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.postCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompaniesApiFp(configuration)
    return {
        /**
         * Soft deletes the company with the specified ID. The current state of a company is also published in Kafka with exactly the same data structure in the `accounts.company.entity.v1` topic with the `companyId` header set to the company ID.
         * @param {CompaniesApiDeleteCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany(requestParameters: CompaniesApiDeleteCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCompany(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the company with the specified ID. The current state of a company is also published in Kafka with exactly the same data structure in the `accounts.company.entity.v1` topic with the `companyId` header set to the company ID.
         * @param {CompaniesApiGetCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(requestParameters: CompaniesApiGetCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.getCompany(requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve limited public information about a company by its UUID. This endpoint is publicly accessible and does not require authentication. Returns only the company ID and name.
         * @summary Get public company information
         * @param {CompaniesApiGetPublicCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCompany(requestParameters: CompaniesApiGetPublicCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicCompanyResponse> {
            return localVarFp.getPublicCompany(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies a JSON Patch document to partially update a company. Only the fields provided in the patch document will be updated; all other fields remain unchanged.  Expected error types for bad requests: - error:account@bikeleasing:context-missing - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:invalid-patch-operation 
         * @param {CompaniesApiPatchCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCompany(requestParameters: CompaniesApiPatchCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.patchCompany(requestParameters.companyId, requestParameters.patchDocumentInner, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new company.  If a company is created with a Bikeleasing context, the client is allowed to create it with a CRM Id and a company code. In that case both fields are required and the account service will not generate a company code.  Expected error types for bad requests: - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:context-missing - error:account@bikeleasing:crm-id-and-company-code-required - error:account@bikeleasing:active-company-required - error:account@bikeleasing:company-code-must-be-unique 
         * @param {CompaniesApiPostCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompany(requestParameters: CompaniesApiPostCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.postCompany(requestParameters.company, requestParameters.bypassConflicts, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteCompany operation in CompaniesApi.
 * @export
 * @interface CompaniesApiDeleteCompanyRequest
 */
export interface CompaniesApiDeleteCompanyRequest {
    /**
     * The company identifier
     * @type {string}
     * @memberof CompaniesApiDeleteCompany
     */
    readonly companyId: string
}

/**
 * Request parameters for getCompany operation in CompaniesApi.
 * @export
 * @interface CompaniesApiGetCompanyRequest
 */
export interface CompaniesApiGetCompanyRequest {
    /**
     * The company identifier
     * @type {string}
     * @memberof CompaniesApiGetCompany
     */
    readonly companyId: string
}

/**
 * Request parameters for getPublicCompany operation in CompaniesApi.
 * @export
 * @interface CompaniesApiGetPublicCompanyRequest
 */
export interface CompaniesApiGetPublicCompanyRequest {
    /**
     * The unique identifier of the company
     * @type {string}
     * @memberof CompaniesApiGetPublicCompany
     */
    readonly uuid: string
}

/**
 * Request parameters for patchCompany operation in CompaniesApi.
 * @export
 * @interface CompaniesApiPatchCompanyRequest
 */
export interface CompaniesApiPatchCompanyRequest {
    /**
     * The company identifier
     * @type {string}
     * @memberof CompaniesApiPatchCompany
     */
    readonly companyId: string

    /**
     * 
     * @type {Array<PatchDocumentInner>}
     * @memberof CompaniesApiPatchCompany
     */
    readonly patchDocumentInner: Array<PatchDocumentInner>

    /**
     * The expected version of the resource, as returned in the &#x60;etag&#x60; response. If the version does not match the current version of the resource, a &#x60;412 Precondition Failed&#x60; response is returned.  It is important that the If-Match header encloses the ETag value in double quotes, as specified in [RFC 7232, Section 3.1](https://datatracker.ietf.org/doc/html/rfc7232#section-3.1) to prevent parsing issues.  This header can be used to implement optimistic concurrency control. If not provided, no version check is performed and the update is applied unconditionally. 
     * @type {string}
     * @memberof CompaniesApiPatchCompany
     */
    readonly ifMatch?: string
}

/**
 * Request parameters for postCompany operation in CompaniesApi.
 * @export
 * @interface CompaniesApiPostCompanyRequest
 */
export interface CompaniesApiPostCompanyRequest {
    /**
     * 
     * @type {Company}
     * @memberof CompaniesApiPostCompany
     */
    readonly company: Company

    /**
     * When set to \&quot;true\&quot;, the server will skip checking for potential duplicate companies. This header should only be used in special cases where the client is certain that the data is valid and wants to bypass these checks. 
     * @type {'true' | 'false'}
     * @memberof CompaniesApiPostCompany
     */
    readonly bypassConflicts?: PostCompanyBypassConflictsEnum
}

/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
export class CompaniesApi extends BaseAPI {
    /**
     * Soft deletes the company with the specified ID. The current state of a company is also published in Kafka with exactly the same data structure in the `accounts.company.entity.v1` topic with the `companyId` header set to the company ID.
     * @param {CompaniesApiDeleteCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public deleteCompany(requestParameters: CompaniesApiDeleteCompanyRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).deleteCompany(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the company with the specified ID. The current state of a company is also published in Kafka with exactly the same data structure in the `accounts.company.entity.v1` topic with the `companyId` header set to the company ID.
     * @param {CompaniesApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getCompany(requestParameters: CompaniesApiGetCompanyRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).getCompany(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve limited public information about a company by its UUID. This endpoint is publicly accessible and does not require authentication. Returns only the company ID and name.
     * @summary Get public company information
     * @param {CompaniesApiGetPublicCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getPublicCompany(requestParameters: CompaniesApiGetPublicCompanyRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).getPublicCompany(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies a JSON Patch document to partially update a company. Only the fields provided in the patch document will be updated; all other fields remain unchanged.  Expected error types for bad requests: - error:account@bikeleasing:context-missing - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:invalid-patch-operation 
     * @param {CompaniesApiPatchCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public patchCompany(requestParameters: CompaniesApiPatchCompanyRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).patchCompany(requestParameters.companyId, requestParameters.patchDocumentInner, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new company.  If a company is created with a Bikeleasing context, the client is allowed to create it with a CRM Id and a company code. In that case both fields are required and the account service will not generate a company code.  Expected error types for bad requests: - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:context-missing - error:account@bikeleasing:crm-id-and-company-code-required - error:account@bikeleasing:active-company-required - error:account@bikeleasing:company-code-must-be-unique 
     * @param {CompaniesApiPostCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public postCompany(requestParameters: CompaniesApiPostCompanyRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).postCompany(requestParameters.company, requestParameters.bypassConflicts, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PostCompanyBypassConflictsEnum = {
    True: 'true',
    False: 'false'
} as const;
export type PostCompanyBypassConflictsEnum = typeof PostCompanyBypassConflictsEnum[keyof typeof PostCompanyBypassConflictsEnum];
